import React from 'react';

// Error Boundary genérico y reutilizable. Se usa dos veces en la app:
//  - Envolviendo <App/> en index.js: último recurso ante errores catastróficos
//    (p. ej. dentro de AuthProvider/ThemeProvider/Router).
//  - Envolviendo el contenido de cada página dentro de Layout.js: si una sola
//    pantalla falla al renderizar, el sidebar/header siguen intactos y el
//    usuario puede navegar a otra pantalla sin recargar la SPA entera.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      // Solo en desarrollo mostramos detalle técnico (stack) en consola.
      console.error('ErrorBoundary capturó un error:', error, info?.componentStack);
    } else {
      console.error('Ocurrió un error inesperado en la aplicación.');
    }
  }

  reintentar = () => {
    // Recarga completa: evita reintentar el render con el mismo estado roto.
    window.location.reload();
  };

  irADashboard = () => {
    window.location.href = '/dashboard';
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={styles.contenedor}>
        <div style={styles.tarjeta}>
          <div style={styles.icono} aria-hidden="true">⚠️</div>
          <h2 style={styles.titulo}>Algo salió mal</h2>
          <p style={styles.texto}>
            Ocurrió un problema inesperado al mostrar esta pantalla. Puedes intentar de nuevo
            o volver al panel principal.
          </p>
          <div style={styles.acciones}>
            <button onClick={this.reintentar} style={styles.botonPrimario}>Reintentar</button>
            <button onClick={this.irADashboard} style={styles.botonSecundario}>Volver al panel</button>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  contenedor: {
    minHeight: '260px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px',
  },
  tarjeta: {
    maxWidth: '420px', width: '100%', textAlign: 'center', background: 'var(--card, #16191F)',
    border: '1px solid var(--border, #232B39)', borderRadius: '14px', padding: '32px 28px',
    color: 'var(--text, #F3F4F6)',
  },
  icono: { fontSize: '32px', marginBottom: '10px' },
  titulo: { fontSize: '18px', fontWeight: '800', margin: '0 0 8px' },
  texto: { fontSize: '13.5px', color: 'var(--gray, #9CA3AF)', margin: '0 0 20px', lineHeight: '1.5' },
  acciones: { display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' },
  botonPrimario: {
    border: 'none', borderRadius: '9px', padding: '10px 18px', background: '#FF2D78', color: '#fff',
    fontSize: '13.5px', fontWeight: '700', cursor: 'pointer',
  },
  botonSecundario: {
    border: '1px solid var(--border, #232B39)', borderRadius: '9px', padding: '10px 18px', background: 'transparent',
    color: 'var(--text, #F3F4F6)', fontSize: '13.5px', fontWeight: '700', cursor: 'pointer',
  },
};
